import React, { Component } from 'react';
import { Menu, Icon, Layout, Button } from 'antd';
import { logout } from '../auth'; 

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;



class NavigationBar extends Component {

    state = {
        collapsed: false,
    };
    
    onCollapse = (collapsed) => {
        console.log(collapsed);
        this.setState({ collapsed });
    }

    // onMenuItemClick = (item, key, keypath) => {
    //     console.log("item " + key + " clicked");
    //     if (key === "2") {
    //         console.log("attempt to sign out")
    //     }
    // }

    onMenuItemSelect({ item, key, selectedKeys }) {
        console.log("item " + key + " clicked");
        if (key === "logout") {
            logout()
            .catch((error) => {
                console.log("faileed to logout")
            });
        }
    }

    // function({ item, key, keyPath })
    

    render() {
        return (
            <Sider
          collapsible={false}
          collapsed={this.state.collapsed}
          onCollapse={this.onCollapse}
        >
          <div className="logo" />
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" onSelect={this.onMenuItemSelect}>
            <Menu.Item key="1">
              <Icon type="play-circle-o" />
              <span>Demos</span>
            </Menu.Item>

            <Menu.Item key="logout">
                <Icon type="logout" />
                <span>Sign Out</span>
            </Menu.Item>
          </Menu>
        </Sider>
        )
    }
}

export default NavigationBar


// WEBPACK FOOTER //
// ./src/components/NavigationBar.js